<template>
  <div class="home-overview-price">
    <div class="container">
      <div class="title">
        <div class="text">{{ $t('runStatus.overview') }}</div>
      </div>
      <div class="price-content">
        <div class="left">
          <div class="price-item">
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('runStatus.datacmc')"
              placement="top-start"
            >
              <div class="title">{{$t('runStatus.ontprice')}}</div>
            </el-tooltip>
            <div class="price">{{ontPrice}}</div>
            <div :class="ontWave>0?'wave':'wave down'">{{ontPer}}</div>
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('runStatus.datacmc')"
              placement="top-start"
            >
              <div class="rank">
                {{$t('runStatus.rank')}}
                <span class="text">{{ontRank}}</span>
              </div>
            </el-tooltip>
          </div>
          <div class="price-item">
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('runStatus.datacmc')"
              placement="top-start"
            >
              <div class="title">{{$t('runStatus.ongprice')}}</div>
            </el-tooltip>
            <div class="price">{{ongPrice}}</div>
            <div :class="ongWave>0?'wave':'wave down'">{{ongPer}}</div>
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('runStatus.datacmc')"
              placement="top-start"
            >
              <div class="rank">
                {{$t('runStatus.rank')}}
                <span class="text">{{ongRank}}</span>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="right">
          <div class="title">{{$t('runStatus.onttx')}}</div>
          <line-chart class="line-chart-style" :labels="chartdata.labels" :data="txn.list" options></line-chart>
        </div>
      </div>
      <div class="content">
        <div class="item click-able" @click="toBlockListPage()">
          <div class="itemTitle">{{ $t('runStatus.CurrentHeight') }}</div>
          <div class="data">
            <countTo
              ref="_dApp"
              :startVal="height.startVal"
              :autoplay="autoplay"
              :endVal="height.endVal"
              :duration="numDuration"
            ></countTo>
          </div>
        </div>
        <div class="item click-able" @click="toTransactionListPage()">
          <div class="itemTitle">{{ $t('runStatus.TxnCount') }}</div>
          <div class="data">
            <countTo
              ref="_dApp"
              :startVal="txNum.startVal"
              :autoplay="autoplay"
              :endVal="txNum.endVal"
              :duration="numDuration"
            ></countTo>
          </div>
        </div>
        <div v-if="!$route.params.net" class="item click-able" @click="toOnlineNodes()">
          <div class="itemTitle">{{ $t('runStatus.NodeCount') }}</div>
          <div class="data">
            <countTo
              ref="_dApp"
              :startVal="nodeNum.startVal"
              :autoplay="autoplay"
              :endVal="nodeNum.endVal"
              :duration="numDuration"
            ></countTo>
          </div>
        </div>
        <div class="item click-able" @click="toAddressListPage()">
          <div class="itemTitle">{{ $t('runStatus.addressCount') }}</div>
          <div class="data">
            <countTo
              ref="_dApp"
              :startVal="addressNum.startVal"
              :autoplay="autoplay"
              :endVal="addressNum.endVal"
              :duration="numDuration"
            ></countTo>
          </div>
        </div>
        <div class="item click-able" @click="toOntIdListPage()">
          <div class="itemTitle">{{ $t('runStatus.ontid') }}</div>
          <div class="data">
            <countTo
              ref="_dApp"
              :startVal="ontidNum.startVal"
              :autoplay="autoplay"
              :endVal="ontidNum.endVal"
              :duration="numDuration"
            ></countTo>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Helper from "./../../helpers/helper.js";
import countTo from "vue-count-to";
import lineChart from "../common/TxLineChart";

export default {
  name: "run-status",
  components: {
    countTo,
    lineChart
  },
  data() {
    return {
      ontPrice: 0,
      ongPrice: 0,
      ontPer: 0,
      ongPer: 0,
      ontRank: 0,
      ongRank: 0,
      ontWave: true,
      ongWave: true,
      num: 1,
      startValue: 0,
      endVal: 10000,
      numDuration: 2000,
      txn: {},
      height: {
        startVal: 0,
        endVal: 0
      },
      txNum: {
        startVal: 0,
        endVal: 0
      },
      nodeNum: {
        startVal: 0,
        endVal: 0
      },
      addressNum: {
        startVal: 0,
        endVal: 0
      },
      ontidNum: {
        startVal: 0,
        endVal: 0
      },
      autoplay: true,
      runTime: 0,
      blockHeight: 0,
      blockTime: 0,
      dealNum: 0,
      node: 0,
      lastheight: 0,
      k: 0
    };
  },
  mounted() {
    this.getRunStatus();
    this.getPrice("ont");
    this.getPrice("ong");
    this.getTableData();
    this.getNodeCountStatus();
    this.intervalBlock = setInterval(() => {
      this.getRunStatus();
    }, 6000);
  },
  watch: {
    $route: "getRunStatus",
    "blockStatus.info": function(val, oldval) {
      if (oldval) {
        this.height.startVal = oldval.block_height;
        this.height.endVal = val.block_height;
        this.txNum.startVal = oldval.tx_count;
        this.txNum.endVal = val.tx_count;
        this.addressNum.startVal = oldval.address_count;
        this.addressNum.endVal = val.address_count;
        this.ontidNum.startVal = oldval.ontid_count;
        this.ontidNum.endVal = val.ontid_count;
      } else {
        this.height.startVal = 0;
        this.height.endVal = val.block_height;
        this.txNum.startVal = 0;
        this.txNum.endVal = val.tx_count;
        this.addressNum.startVal = 0;
        this.addressNum.endVal = val.address_count;
        this.ontidNum.startVal = 0;
        this.ontidNum.endVal = val.ontid_count;
      }
    },
    "nodeCount.info": function(val, oldval) {
      if (oldval) {
        this.nodeNum.startVal =
          oldval.candidate_node_count + oldval.consensus_node_count;
        this.nodeNum.endVal =
          val.candidate_node_count + val.consensus_node_count;
      } else {
        this.nodeNum.startVal = 0;
        this.nodeNum.endVal =
          val.candidate_node_count + val.consensus_node_count;
      }
    },
    TokenPrice: function() {
      if (this.TokenPrice.token === "ont") {
        this.ontPrice = Number(this.TokenPrice.prices.USD.price).toFixed(2);
        this.ontPer =
          Number(this.TokenPrice.prices.USD.percentage).toFixed(2) + "%";
        this.ontRank = this.TokenPrice.rank
          ? "  #" + this.TokenPrice.rank
          : " -";
        this.ontWave =
          Number(this.TokenPrice.prices.USD.percentage).toFixed(2) > 0
            ? true
            : false;
      } else {
        this.ongPrice = Number(this.TokenPrice.prices.USD.price).toFixed(2);
        this.ongPer =
          Number(this.TokenPrice.prices.USD.percentage).toFixed(2) + "%";
        this.ongRank = " -";
        this.ongWave =
          Number(this.TokenPrice.prices.USD.percentage).toFixed(2) > 0
            ? true
            : false;
      }
    },
    chartdata: function() {
      this.txn = this.chartdata.data.txn;
/*       console.log(this.txn); */
    }
  },
  computed: {
    ...mapState({
      blockStatus: state => state.RunStatus.BlockStatus,
      TokenPrice: state => state.RunStatus.TokenPrice.info,
      chartdata: state => state.Statistics.StatisticsData,
      nodeCount: state => state.RunStatus.NodeCount
    })
  },
  methods: {
    setTime() {
      if (this.k < this.addLength) {
        if (this.k >= this.addLength) {
          clearInterval(this.handler); //关闭定时
        }
        this.chartData.splice(0, 1);
        this.chartLabels.splice(0, 1);
        this.chartData.push(this.addDatas[this.addLength - this.k - 1]);
        this.chartLabels.push(this.addLabels[this.addLength - this.k - 1]);
        this.removeData(this.myChart);
        this.addData(this.myChart, this.addDatas[this.addLength - this.k - 1]);

        this.k++;
      }
    },
    toBlockListPage() {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "blockList",
          params: { pageSize: 10, pageNumber: 1 }
        });
      } else {
        this.$router.push({
          name: "blockListDetailTest",
          params: { pageSize: 10, pageNumber: 1, net: "testnet" }
        });
      }
    },
    toTransactionListPage() {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "TransactionList",
          params: { pageSize: 10, pageNumber: 1 }
        });
      } else {
        this.$router.push({
          name: "TransactionListTest",
          params: { pageSize: 10, pageNumber: 1, net: "testnet" }
        });
      }
    },
    toAddressListPage() {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "addressList",
          params: { token: "ont", pageSize: 10, pageNumber: 1 }
        });
      } else {
        this.$router.push({
          name: "addressListTest",
          params: { token: "ont", pageSize: 10, pageNumber: 1, net: "testnet" }
        });
      }
    },
    toOntIdListPage() {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "OntIdList",
          params: { pageSize: 10, pageNumber: 1 }
        });
      } else {
        this.$router.push({
          name: "OntIdListDetailTest",
          params: { pageSize: 10, pageNumber: 1, net: "testnet" }
        });
      }
    },
    toOnlineNodes() {
      /* this.$router.push({ name: 'NodeStakeList'}) */
      window.open("https://node.ont.io/");
    },
    getNodeCountStatus() {
      this.$store.dispatch("getNodeCount").then();
    },
    getRunStatus() {
      this.$store.dispatch("getRunStatus", this.$route.params).then();
    },
    getPrice($token) {
      let params = this.$route.params;
      params.token = $token;
      this.$store.dispatch("getPrice", this.$route.params).then();
    },
    getDay($time) {
      return Helper.getDayFunc($time);
    },
    getTableData() {
      let params = this.$route.params;
      params.day = 30;
      this.$store.dispatch("getStatisticsData", params).then();
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalBlock);
    clearInterval(this.intervalBlock1);
  }
};
</script>
<style>
.el-tooltip__popper.is-light {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border: 0;
  font-size: 12px;
  font-family: Avenir;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  line-height: 14px;
  max-width: 252px;
}
.el-tooltip__popper .popper__arrow {
  display: none;
}
</style>
<style lang="less" scoped>
.click-able {
  cursor: pointer;
  transition: all ease 0.3s;
}
.click-able:hover {
  opacity: 0.5;
  transition: all ease 0.3s;
}
.home-overview-price {
  text-align: left;
  .container {
    padding-top: 80px;
    .title {
      .text {
        font-size: 18px;
        font-family: Explorerfonts-Bold, sans-serif;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 26px;
        padding-bottom: 14px;
      }
    }
    .price-content {
      padding-top: 26px;
      display: flex;
      padding-bottom: 30px;
      .left {
        width: 46%;
        display: flex;
        .price-item {
          padding-right: 90px;
          margin-right: 39px;
          border-right: 1px solid #fafafa;
          .title {
            font-size: 12px;
            font-family: Avenir, sans-serif;
            font-weight: normal;
            color: rgba(0, 0, 0, 1);
            line-height: 14px;
            margin-bottom: 20px;
          }
          .price {
            width: 103px;
            height: 33px;
            font-size: 26px;
            font-family: DINPro;
            color: rgba(0, 0, 0, 1);
            line-height: 33px;
            margin-bottom: 10px;
          }
          .wave {
            width: 39px;
            height: 15px;
            font-size: 12px;
            font-family: DINPro;
            color: #609a22;
            line-height: 15px;
            margin-bottom: 20px;
          }
          .down {
            color: #e02020;
          }
          .rank {
            font-size: 12px;
            font-family: Avenir, sans-serif;
            font-weight: normal;
            color: rgba(0, 0, 0, 0.3);
            line-height: 14px;
            .text {
              margin-left: 10px;
              font-size: 12px;
              font-family: Avenir, sans-serif;
              font-weight: normal;
              color: rgba(0, 0, 0, 1);
              line-height: 14px;
            }
          }
        }
      }
      .right {
        width: 54%;
        .title {
          font-size: 12px;
          font-family: Avenir, sans-serif;
          font-weight: normal;
          color: rgba(0, 0, 0, 1);
          line-height: 14px;
          margin-bottom: 14px;
        }
      }
    }
    .content {
      padding-top: 30px;
      display: flex;
      justify-content: space-between;
      .item {
        /* width: 20%; */
        .data {
          padding-top: 10px;
          font-size: 16px;
          font-family: DINPro, DINPro;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          line-height: 26px;
        }
        .itemTitle {
          font-size: 12px;
          font-family: Avenir;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          line-height: 14px;
        }
      }
    }
  }
}

@media only screen and (max-width: 960px) {
  .home-overview-price {
    text-align: left;
    .container {
      padding-top: 70px;
      .price-content {
        flex-wrap: wrap;
        padding-right: 0px;
        margin-right: 0px;
        padding-bottom: 0;
        .left {
          width: 100%;
          .price-item {
            padding-right: 0px;
            margin-right: 0px;
            width: 50%;
          }
        }
        .right {
          padding-top: 20px;
          width: 100%;
        }
      }
      .content {
        padding-top: 60px;
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 50% !important;
          padding-bottom: 24px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/overviewPrice.vue